import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function AudienceSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-[#FDFAF6]" data-id="element-10">
      <div className="max-w-4xl mx-auto" data-id="element-11">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-12">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1A1A1A] mb-4" data-id="element-13">
            ¿Para Quién Es Este Método?
          </h2>
          <div className="w-24 h-1 bg-[#2D8C4E] mx-auto rounded-full opacity-50" data-id="element-14"></div>
        </motion.div>

        <div className="space-y-6" data-id="element-15">
          <motion.div initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="flex items-center p-6 bg-white rounded-2xl shadow-sm border border-[#F0FDF4]" data-id="element-16">
            <div className="flex-shrink-0 w-10 h-10 rounded-full bg-[#F0FDF4] flex items-center justify-center mr-6" data-id="element-17">
              <Check className="w-5 h-5 text-[#2D8C4E]" data-id="element-18" />
            </div>
            <p className="text-lg text-gray-800 font-medium font-sans" data-id="element-19">
              Mujeres de 33 a 65 años que se sienten agotadas.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="flex items-center p-6 bg-white rounded-2xl shadow-sm border border-[#F0FDF4]" data-id="element-20">
            <div className="flex-shrink-0 w-10 h-10 rounded-full bg-[#F0FDF4] flex items-center justify-center mr-6" data-id="element-21">
              <Check className="w-5 h-5 text-[#2D8C4E]" data-id="element-22" />
            </div>
            <p className="text-lg text-gray-800 font-medium font-sans" data-id="element-23">
              Personas que notan que su metabolismo es más lento y la ropa
              ajusta más.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="flex items-center p-6 bg-white rounded-2xl shadow-sm border border-[#F0FDF4]" data-id="element-24">
            <div className="flex-shrink-0 w-10 h-10 rounded-full bg-[#F0FDF4] flex items-center justify-center mr-6" data-id="element-25">
              <Check className="w-5 h-5 text-[#2D8C4E]" data-id="element-26" />
            </div>
            <p className="text-lg text-gray-800 font-medium font-sans" data-id="element-27">
              Quienes quieren una solución práctica, sin dietas extremas ni
              entrenamientos agotadores.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}